module.exports = __webpack_public_path__ + "static/img/Rachel_Kyte_SustainableEnergyForAll.bb1c933.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Rachel_Kyte_SustainableEnergyForAll.jpg
// module id = KFGc
// module chunks = 0